// Dependencies
import {
  ARTICULOS_REQUEST,
  ARTICULOS_OK,
  ARTICULOS_REFRESH,
  ARTICULOS_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ARTICULOS_REQUEST:
      return { ...state, loading: true };
    case ARTICULOS_REFRESH:
      return { ...state, refreshing: true };
    case ARTICULOS_ERROR:
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: action.payload.error,
      };
    case ARTICULOS_OK:
      return {
        ...state,
        loading: false,
        refreshing: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
